export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const ERROR_CART_ITEM = "ERROR_CART_ITEM";
